import React from 'react'
import PropTypes from 'prop-types'
import { Desc, Counter, Item, ItemHeadline, Wrapper } from './Step.style'

const Step = ({ index, headline, description }) => (
  <Wrapper>
    <Item key={`step_${index.toString()}`}>
      <Counter>{String(index).padStart(2, '0')}</Counter>
      {!!headline && <ItemHeadline>{headline}</ItemHeadline>}
      {!!description && (
        <Desc
          dangerouslySetInnerHTML={{
            __html: description.description.replace(/\n/g, '<br> '),
          }}
        />
      )}
    </Item>
  </Wrapper>
)

Step.propTypes = {
  index: PropTypes.number,
  headline: PropTypes.string,
  description: PropTypes.shape({
    description: PropTypes.string,
  }),
}

Step.defaultProps = {
  index: 0,
  headline: '',
  description: {
    description: '',
  },
}

export default Step
